export default "__VITE_ASSET__EP3PV8pc__"